
@switch (type) {
  @case (types.RECTANGLE) {
    <div
      sizeable
      [sizebleDisabled]="!resizable"
      [sizebleContainer]="element?.nativeElement?.parentElement?.parentElement"
      class="hotspot-area"
      [ngClass]="cssClasses"
      [style.animationDelay.ms]="animationDelayMs"
      [borderStyle]="border"
      (click)="markerClick.emit()"
      (sizeChange)="onSizeChange($event)">
      <lib-question-answer-option-code [index]="index" class="area-code"></lib-question-answer-option-code>
      @if (selected) {
        <div class="selected-indicator">
          <lib-icon icon="check" [size]="14"></lib-icon>
        </div>
      }
      @if (resizable) {
        <div #sizeableHandle class="resize-handle">
          <lib-icon icon="notches"></lib-icon>
        </div>
      }
    </div>
  }
  @default {
    <div
      class="hotspot-marker"
      [attr.data-index]="index + 1"
      [ngClass]="cssClasses"
      [style.animationDelay.ms]="animationDelayMs"
      [ngStyle]="{
        '--lms-hotspot-icon-color': iconColor,
        '--lms-hotspot-active-background-color': activeStyle?.backgroundColor,
        '--lms-hotspot-active-background-blur': activeStyle?.backgroundBlur,
        '--lms-hotspot-active-icon-color': activeStyle?.iconColor
      }"
      [borderStyle]="active ? activeStyle?.border : border"
      (click)="markerClick.emit()">
      <div class="marker-icon" [class.empty]="layout === layouts.PLUS && !icon">
        @switch (layout) {
          @case (layouts.PLUS) {
            <lib-icon [icon]="icon" [size]="20"></lib-icon>
          }
          @case (layouts.LETTER) {
            <lib-question-answer-option-code [index]="index"></lib-question-answer-option-code>
          }
          @default {
            {{ index + 1 }}
          }
        }
      </div>
      @if (visited) {
        <div class="visited-icon">
          <lib-icon icon="check-circle" [fill]="true" [size]="20"></lib-icon>
        </div>
      }
    </div>
  }
}

@if (showEditButton) {
  <div class="action-buttons" (mousedown)="$event.stopPropagation()">
    <button mat-icon-button class="button button--icon button--icon-extra-small button--black mdc-icon-button" (click)="edit.emit()">
      <lib-icon icon="pencil-simple"></lib-icon>
    </button>
  </div>
}
